import React, { useEffect, useState } from "react";
import api from "@/lib/apiClient";

export default function AsSeenIn() {
  const [logos, setLogos] = useState([]);
  useEffect(() => { api.get("/media-logos").then(({ data }) => setLogos(data)).catch(() => {}); }, []);
  if (!logos.length) return null;
  const loop = [...logos, ...logos];

  return (
    <section className="bg-npst-bg border-y border-npst-line py-12 overflow-hidden" data-testid="as-seen-in" aria-label="Media coverage of the Trust">
      <style>{`
        @keyframes npst-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .npst-marquee-track { display: flex; width: max-content; animation: npst-marquee 40s linear infinite; }
        .npst-marquee:hover .npst-marquee-track { animation-play-state: paused; }
        @media (prefers-reduced-motion: reduce) { .npst-marquee-track { animation: none; } }
      `}</style>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 text-center">
        <div className="label-eyebrow text-npst-gold">As Seen In</div>
      </div>
      <div className="npst-marquee relative w-full"
        style={{ maskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)", WebkitMaskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)" }}>
        <div className="npst-marquee-track" data-testid="as-seen-in-track">
          {loop.map((l, i) => (
            <div key={`${l.id}-${i}`} className="flex items-center justify-center px-10 shrink-0" aria-hidden={i >= logos.length}>
              <img src={l.image} alt={l.name} title={l.name} loading="lazy"
                className="h-10 sm:h-12 w-auto object-contain opacity-70 hover:opacity-100 grayscale hover:grayscale-0 transition-all duration-300"
                data-testid="as-seen-in-logo" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
